import type {FormMakerState} from '@FormMakerReact/form-maker.types';
import {getRelativeTimeString} from '@Utils/relative-save-time.util';
import type {SaveStateContext} from './save-badge.types';
import {SaveStateKind} from './save-badge.types';

export function getSaveStateKind(state: FormMakerState, {isDraft}: SaveStateContext): SaveStateKind {
  if (state.saveFailed) {
    return SaveStateKind.FAILED;
  }
  if (state.isSaving) {
    return SaveStateKind.SAVING;
  }
  if (state.hasUnsavedChanges) {
    return SaveStateKind.UNSAVED;
  }
  if (isDraft) {
    return SaveStateKind.AUTOSAVE_OFF;
  }
  return SaveStateKind.SAVED;
}

export function getRelativeSavedTooltip(lastSavedAt: number | null): string {
  return getRelativeTimeString(Date.now(), lastSavedAt);
}
